import axios from "axios"

import { API } from "@/utils/http"

export const getTariffsHistory = ({ pageSize = 10, page = 1, query = {} } = {}) => {
  const paginationQuery = { limit: pageSize, offset: (page - 1) * pageSize }
  const params = { ...query, ...paginationQuery }

  return API.get("/v2/seller/billing/operations", { params })
}

export const getInvoices = ({ pageSize = 10, page = 1, query = {}, signal } = {}) => {
  const paginationQuery = { limit: pageSize, offset: (page - 1) * pageSize }
  const params = { ...query, ...paginationQuery }

  return API.get("/v2/seller/billing/invoices", {
    params,
    signal
  })
}

export const getTariffPlans = () => {
  const params = { limit: 100, offset: 0 }

  return API.get("/v2/seller/billing/tariffs", { params })
}
